<template>
  <div class="block-intro" :style="headerCompensation">
    <div class="block-intro__container">
      <h1 v-html="block.title"></h1>
      <div v-if="block.body" v-html="block.body" />
    </div>
  </div>
</template>

<script>
import { headerCompensation } from '@/mixins';

export default {
  name: 'BlockIntro',
  props: {
    block: [Array, Object]
  },
  mixins: [headerCompensation]
};
</script>

<style lang="postcss">
.block-intro {
  @apply bg-brand-white;
  @apply pt-16;
  &__container {
    @apply max-w-max mx-auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  h1 {
    @apply font-ginto-black text-center;
    font-size: calc(38px + (80 - 38) * (100vw - 640px) / (1920 - 640));
  }
  p {
    font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
    @apply font-ginto-regular;
    &:not(:last-child) {
      @apply mb-8;
    }
    a {
      @apply border-b border-brand-blue;
      @apply pb-1;
    }
    &:only-of-type {
      @apply text-center;
    }
  }
}
</style>
